import { SimuladorState } from "./state";

export const mutations = {
    setResultado(state: SimuladorState, data: any) {
        state.resultado = data;
    },
    setTipos(state: SimuladorState, data: any[]) {
        state.tipos = data;
    },
    setPisos(state: SimuladorState, pisos: number[]) {
        state.pisos = pisos;
    },
    setCuotaInicial(state: SimuladorState, cuota_inicial: number[]) {
        state.cuota_inicial = cuota_inicial;
    },
};